import { DataBean } from "../DataBean";

export class TaxReporting extends DataBean {

    public async setInfoForTaxReportingToPayrollFactor(idPayrollFactor: any, idElectronicPayroll: any,): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.PayrollFactor_setInfoForTaxReportingToPayrollFactor_Number_Number", [idPayrollFactor, idElectronicPayroll]);
    }

}